import createCampoOsForm from './createCampoOsFormModel';
const {
  formField: {
    // DATOS CARGO 
    name,
    etiqueta,
    tipoCampo,
    isRequired,
    opciones,
    categoria,
    dependencias,
    formula
  } 
} = createCampoOsForm;

export default {
  [name.name]: '',
  [etiqueta.name]: '',
  [tipoCampo.name]: null,
  [isRequired.name]: false,
  [opciones.name]: '',
  [categoria.name]: '',
  [dependencias.name]: [], 
  [formula.name]: '',
};

